module.exports = __webpack_public_path__ + "static/media/like-badge.c58fd730.svg";